import { c as _c } from "react/compiler-runtime";
import type { PolicyCheckData } from '@newfront-insurance/ai-api';
import { IconTick, colors, IconExternal2, TextLink } from '@newfront-insurance/core-ui';
export function PolicyCheckingStatusCard(t0) {
  const $ = _c(5);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconTick color={colors.grass["500"]} size={16} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col"><div className="text-steel-500 font-semibold">Policy check completed</div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-3"><IconExternal2 />View full analysis</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data.resultUrl) {
    t4 = <div className="flex w-full flex-col gap-4 rounded-md border py-4 sm:px-4"><div className="flex items-center gap-3">{t1}{t2}<div className="ml-auto flex items-center gap-2"><TextLink href={data.resultUrl} target="_blank" underline={false}>{t3}</TextLink></div></div></div>;
    $[3] = data.resultUrl;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}